import * as React from 'react';
import ReactTable, { Column } from 'react-table';
import { dateParser } from '@common/dateParser';
import { ModalProps, Spinner } from '@common/components';
import { DocumentViewModel, FileViewModel } from '@models/Document';
import { documentService } from '@services/DocumentService';
import { FileUpload, FileRemove } from '@common/components/file-upload';
import { VendorViewModel, VendorDocumentExpire } from '@models/Vendor';

export interface VendorDocumentTableComponentProperties {
  readonly vendorVm: VendorViewModel;
  readonly fileList: DocumentViewModel[];
  readonly isModal: boolean;
  readonly uploadCallback: (fileVMs: FileViewModel[], vendor: VendorViewModel) => void;
  readonly removeCallback: (fileId: number, vendor: VendorViewModel) => void;
  readonly toggleModal: (modalProps?: ModalProps) => void;
  readonly uploadModalTitle: string;
  readonly removeModalTitle: string;
  readonly isLoading: boolean;
  readonly canRemove?: boolean;
  readonly documentsLoading: boolean;
}

export class VendorDocumentTableComponent extends React.Component<VendorDocumentTableComponentProperties> {
  private readonly apiRoot: string;
  constructor(props: VendorDocumentTableComponentProperties) {
    super(props);
    this.apiRoot = documentService.getRootPath();
  }

  showFileUploadModal = () => {
    const { vendorVm } = this.props;
    this.props.toggleModal({
      title: this.props.uploadModalTitle,
      component: FileUpload,
      saveCallback: this.loadFile.bind(this),
      saveLabel: 'Save File',
      childProps: { types: true, vendorVm }
    });
  };

  loadFile(fileVMs: FileViewModel[], vendor: VendorViewModel) {
    this.props.toggleModal();
    this.props.uploadCallback(fileVMs, vendor);
  }

  showFileRemoveModal = (fileId: number, filename: string, documentType: number) => {
    const { vendorVm } = this.props;
    this.props.toggleModal({
      title: this.props.removeModalTitle,
      component: FileRemove,
      saveLabel: 'Remove File',
      saveCallback: this.removeFile.bind(this),
      childProps: { fileId: fileId, filename: filename, vendorVm, documentType }
    });
  };

  removeFile(fileId: number, vendor: VendorViewModel) {
    this.props.toggleModal();
    this.props.removeCallback(fileId, vendor);
  }

  renderActionColumn = (d: DocumentViewModel) => {
    const documentType = d.documentType ? d.documentType.id : 0;
    return (
      <div>
        <a
          className="fa fa-times fa-2x pointer"
          onClick={() => {
            this.showFileRemoveModal(d.id, d.fileName, documentType);
          }}
        />
      </div>
    );
  };

  render() {
    if (this.props.isLoading) {
      return (
        <div className="row center-xs middle-xs">
          <Spinner />
        </div>
      );
    }

    const tableData = this.props.fileList.map((file: DocumentViewModel) => {
      let expirationDate = null;
      switch (file.documentType && file.documentType.id) {
        case VendorDocumentExpire.LiabilityExpiration:
          expirationDate = this.props.vendorVm.liabilityExpiration;
          break;
        case VendorDocumentExpire.WorkersCompExpiration:
          expirationDate = this.props.vendorVm.sdiExpiration;
          break;
        case VendorDocumentExpire.LicenseExpiration:
          expirationDate = this.props.vendorVm.licenseExpiration;
          break;
        default:
          break;
      }
      return { ...file, expirationDate };
    });

    const columns: Column[] = [
      {
        accessor: (d: DocumentViewModel) =>
          d.documentType ? (
            <a href={this.apiRoot + '/' + d.id + '/download'} download={d.fileName}>
              {d.documentType.value}
            </a>
          ) : (
            <a href={this.apiRoot + '/' + d.id + '/download'} download={d.fileName}>
              {d.fileName}
            </a>
          ),
        id: 'type',
        Header: 'Type'
      },
      {
        accessor: 'createdDate',
        id: 'date',
        Header: 'Upload Date',
        Cell: (props: { value: string }) => <>{props.value && dateParser.parse(props.value).format('MM/DD/YYYY')}</>,
        sortable: true
      },
      {
        accessor: 'expirationDate',
        id: 'expireDate',
        Header: 'Expiration Date',
        Cell: (props: { value: string }) => <>{props.value && dateParser.parse(props.value).format('MM/DD/YYYY')}</>,
        sortable: true
      },
      {
        accessor: (d: DocumentViewModel) => d,
        Cell: (props: { value: DocumentViewModel }) => {
          return this.renderActionColumn(props.value);
        },
        id: 'Action',
        Header: 'Actions',
        sortable: false,
        maxWidth: 100
      }
    ];

    return (
      <div>
        <div className="row bottom-xs">
          <div className="col-md-12">
            <h3>Documents</h3>
          </div>
          <div className="col-lg-12 mb-10">
            <button onClick={this.showFileUploadModal} className="btn btn-primary">
              Upload Files
            </button>
          </div>
        </div>
        <ReactTable
          onPageChange={() => {
            Array.from(document.getElementsByClassName('rt-tbody')).forEach(element => {
              element.scrollTop = 0;
            });
          }}
          className="-striped -highlight"
          columns={columns}
          data={tableData}
          manual={true}
          defaultPageSize={10}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-documents/vendor-document-table.component.tsx